import React from 'react';

import { Connect } from '@rover/react-lib/src/components/utils/Redux';
import { A11yContextProvider } from '@rover/react-lib/src/context/A11yContext';

import SearchBox from './SearchBox';
import { actions as searchBoxActions, selectors as searchBoxSelectors } from './SearchBox.duck';

export interface Props {
  className?: string;
}

const actions = {
  updateFilters: searchBoxActions.updateFilters,
};

const selector = (state) => ({
  filters: searchBoxSelectors.getFilters(state),
  serviceType: searchBoxSelectors.getServiceType(state),
  serviceTypeOptions: searchBoxSelectors.getApplicableServiceTypeOptions(state),
});

// Connect.jsx is currently untyped

const SearchBoxContainer = (props: Props): JSX.Element => {
  return (
    <Connect actions={actions} selector={selector}>
      {(connectedProps) => (
        <A11yContextProvider>
          <SearchBox {...connectedProps} {...props} />
        </A11yContextProvider>
      )}
    </Connect>
  );
};

export default SearchBoxContainer;
